import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: "",
  id: "",
  firstName: "",
  lastName: "",
  email: "",
  mobileNoRe: null,

};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserDetails(state, { payload }) {
      return { ...state, ...payload };
    },
    setUserProfiles(state, { payload }) {
      return { ...state, ...payload };
    },
    clearUserDetails(state) {
      return initialState;
    },
    setUserOtpAndEmail(state, { payload }) {
      return { ...state, ...payload };
    },
  },
});

export const {
  setUserDetails,
  setUserProfiles,
  clearUserDetails,
  setUserOtpAndEmail,
} = userSlice.actions;

export default userSlice.reducer;
